module.exports = __webpack_public_path__ + "static/course-banner-d1ac78388986e54da9e9324ce236b9eb.png";